export default __webpack_public_path__ + "static/media/decode.35dceb45.svg";